/**
 * Lib.Common: Layout component declarations
 */


import ibCarousel           from './ib-carousel.vue';
import ibCol                from './ib-col.vue';
import ibContainer          from './ib-container.vue';
import ibContext            from './ib-context.vue';
import ibRow                from './ib-row.vue';
import ibTab                from './ib-tab.vue';
import ibTabs               from './ib-tabs.vue';


export default [
    ibCarousel,
    ibCol,
    ibContainer,
    ibContext,
    ibRow,
    ibTab,
    ibTabs
];
